import { ReactNode } from 'react'
import { match } from 'ts-pattern'
import {
  Text,
  GreyGrey80,
  Primary14SemiBold,
  Primary16SemiBold,
  Flex
} from '@sequencehq/core-components'

type Props = {
  title: string
  titleSize?: 'lg' | 'md'
  children: ReactNode
  'data-testid'?: string
}

export const Section = ({
  title,
  titleSize = 'md',
  children,
  'data-testid': dataTestId
}: Props) => {
  const titleProps = match(titleSize)
    .with('lg', () => ({ ...Primary16SemiBold }))
    .with('md', () => ({ ...Primary14SemiBold }))
    .exhaustive()

  return (
    <Flex gap="16px" flexDir="column" data-testid={dataTestId}>
      <Text {...titleProps} color={GreyGrey80}>
        {title}
      </Text>

      {children}
    </Flex>
  )
}
